// extracted by mini-css-extract-plugin
export default {"Installations":"Installations_Installations__X4F63"};